<template>
    <transition name="el-zoom-in-top">
    <div class="transition-box" v-show="showDiv">

       <!-- <div style="border-bottom:0.1px solid #EEE9E9;height: 200px" >
            <el-image :src="'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg'" fit="cover" style="height: 200px;width: 100%"></el-image>

        </div>-->
        <div style="border-bottom:0.1px solid #EEE9E9;">
            <span><h1 style="text-align: center">鼓楼区第十七届小学生象棋比赛  </h1></span><!--特殊设置关键词：省赛-->
        </div>

        <el-form ref="elForm" :model="formData" :rules="rules" size="medium" label-width="100px"
                 label-position="left">
            <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;" >
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="团体名称" prop="title">
                        <el-input v-model="formData.title" placeholder="请输入团体名称" clearable :style="{width: '100%'}">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="领队姓名" prop="orgUser">
                        <el-input v-model="formData.orgUser" placeholder="请输入领队姓名" clearable :style="{width: '100%'}">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center" align="middle" style="border-bottom:0.1px solid #EEE9E9;" v-show="false">
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="团体性质" prop="type">
                        <el-radio-group v-model="formData.type" size="medium">
                            <el-radio v-for="(item, index) in typeOptions" :key="index" :label="item.value"
                                     :disabled="item.disabled">{{item.label}}</el-radio>
                         </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center" align="top"  v-show="formData.type=='机构'" style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="营业执照" prop="field119" required ><!--:action="field119Action"-->
                        <el-upload  ref="field119"
                                    :file-list="file1List"
                                    action="string"
                                    :auto-upload="false"
                                    :limit="1"
                                    :on-exceed="handlerExceed"
                                    :on-change="file1Upload" list-type="picture" accept="image/*,application/pdf">
                            <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip" style="color: red">只能上传小于10Mb的文件;文件格式：jpg,png,pdf</div>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center" align="center" style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="报名表原件（盖章）" prop="field120" required>
                        <el-upload ref="field120"
                                   :file-list="file2List"
                                   action="string"
                                   :auto-upload="false"
                                   :limit="1"
                                   :on-exceed="handlerExceed"
                                   :on-change="file2Upload" list-type="picture" accept="image/*,application/pdf">
                            <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip" style="color: red">只能上传小于10Mb的文件;文件格式：jpg,png,pdf</div>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="报名表Excel" prop="field122" required>
                        <el-upload ref="field122"
                                   :file-list="file3List"
                                   action="string"
                                   :auto-upload="false"
                                   :limit="1"
                                   :on-exceed="handlerExceed"
                                   :on-change="file3Upload" list-type="picture" accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
                            <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip" style="color: red">只能上传小于20Mb的文件;文件格式：xls,xlsx</div>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>

            <!--省赛无需学籍证明 其它比赛可能要-->
            <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10"  style="margin-top: 20px">
                    <el-form-item label="学籍证明" prop="field126" required>
                        <el-upload ref="field126"
                                   :file-list="file5List"
                                   action="string"
                                   :auto-upload="false"
                                   :limit="1"
                                   :on-exceed="handlerExceed"
                                   :on-change="file5Upload" list-type="picture" accept="image/*,application/pdf,.rar,.zip,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
                            <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip" style="color: red">只能上传小于30Mb的文件;文件格式：jpg,png,pdf,zip</div>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10"  style="margin-top: 20px">
                    <el-form-item label="团体保单" prop="field125" required>
                        <el-upload ref="field125"
                                   :file-list="file4List"
                                   action="string"
                                   :auto-upload="false"
                                   :limit="1"
                                   :on-exceed="handlerExceed"
                                   :on-change="file4Upload" list-type="picture" accept="image/*,application/pdf,.rar,.zip,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
                            <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip" style="color: red">只能上传小于30Mb的文件;文件格式：jpg,png,pdf,zip</div>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>


           <!-- <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10"  style="margin-top: 20px">
                    <el-form-item label="等级证书（8-16 岁组必填）" prop="field128" required>
                        <el-upload ref="field128"
                                   :file-list="file7List"
                                   action="string"
                                   :auto-upload="false"
                                   :limit="1"
                                   :on-exceed="handlerExceed"
                                   :on-change="file7Upload" list-type="picture" accept="image/*,application/pdf,.rar,.zip,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
                            <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip" style="color: red">只能上传小于30Mb的文件;文件格式：jpg,png,pdf,zip</div>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10"  style="margin-top: 20px">
                    <el-form-item label="获奖证书（跨龄参赛必填）" prop="field129" required>
                        <el-upload ref="field129"
                                   :file-list="file8List"
                                   action="string"
                                   :auto-upload="false"
                                   :limit="1"
                                   :on-exceed="handlerExceed"
                                   :on-change="file8Upload" list-type="picture" accept="image/*,application/pdf,.rar,.zip,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
                            <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip" style="color: red">只能上传小于30Mb的文件;文件格式：jpg,png,pdf,zip</div>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row type="flex" justify="center" align="center" style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="收款证明" prop="field133" required>
                        <el-upload ref="field133"
                                   :file-list="file6List"
                                   action="string"
                                   :auto-upload="false"
                                   :limit="1"
                                   :on-exceed="handlerExceed"
                                   :on-change="file6Upload" list-type="picture" accept="image/*,application/pdf">
                            <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip" style="color: red">只能上传小于10Mb的文件;文件格式：jpg,png,pdf</div>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>-->

            <!--完成后弹出群二维码-->
            <el-dialog :close-on-click-modal="false"  :visible="qrVisible"  @close="qrClose" title="群二维码"><!-- @open="onOpen" v-bind="$attrs" v-on="$listeners"-->


                <el-image :src="'http://img.tmxiangqi.com/teamQrCode.jpg?20240520'">
                    <div slot="placeholder" class="image-slot">
                        加载中<span class="dot">...</span>
                    </div>
                </el-image>


                <div slot="footer">
                    <el-button type="primary" @click="qrClose">确定</el-button>
                </div>
            </el-dialog>

            <!--二维码end-->

            <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;">
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="领队手机号" prop="phone">
                        <el-input v-model="formData.phone" disabled @blur="validatePhone" placeholder="请输入领队手机号" clearable :style="{width: '100%'}">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--<el-row type="flex" justify="center" align="top" >
                <el-col :span="10" style="margin-top: 20px">
                    <el-form-item label="短信验证码" prop="captcha">
                        <el-input v-model="formData.captcha" placeholder="请输入短信验证码" clearable :style="{width: '100%'}">
                            <template slot="append">
                                <el-button type="primary" v-if="unSend" style="background-color: dodgerblue;color: white" @click="sendSms" v-preventReClick>发送验证码</el-button>
                                <el-button type="primary" v-else style="background-color: dodgerblue;color: white" >{{smsTime}}</el-button>
                            </template>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>-->


            <el-dialog title="报名查询" :visible.sync="showCheck" :fullscreen="true"  :center="true" :show-close="false" :close-on-press-escape="false">
                <el-form  size="medium" label-width="100px" label-position="left">
                    <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;" >
                        <el-col :span="10" style="margin-top: 20px">
                            <el-form-item label="团体名称" prop="title">
                                <el-input v-model="formData.checkTitle" placeholder="请输入团体名称" clearable :style="{width: '100%'}">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex" justify="center" align="top" style="border-bottom:0.1px solid #EEE9E9;">
                        <el-col :span="10" style="margin-top: 20px">
                            <el-form-item label="领队手机号" prop="phone">
                                <el-input v-model="formData.checkPhone"  @blur="validatePhone" placeholder="请输入领队手机号" clearable :style="{width: '100%'}">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex" justify="center" align="top" >
                        <el-col :span="10" style="margin-top: 20px">
                            <el-form-item label="短信验证码" prop="captcha">
                                <el-input v-model="formData.checkCaptcha" placeholder="请输入短信验证码" clearable :style="{width: '100%'}">
                                    <template slot="append">
                                        <el-button type="primary" v-if="unSend" v-preventReClick  style="background-color: dodgerblue;color: white" @click="sendCheckSms">发送验证码</el-button>
                                        <el-button type="primary" v-else style="background-color: dodgerblue;color: white" >{{smsTime}}</el-button>
                                    </template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>


                    <el-table :data="gridData2" v-show="showProgress">
                        <el-table-column property="title" label="学生姓名" width="150"></el-table-column>
                        <el-table-column property="org" label="所属团体" width="250"></el-table-column>
                        <el-table-column property="grade" label="分组" width="200"></el-table-column>
                        <el-table-column property="sex" label="性别" width="100"></el-table-column>
                        <el-table-column property="school" label="就读学校" width="200"></el-table-column>
                        <el-table-column property="phone" label="手机号" width="200"></el-table-column>
                        <el-table-column property="idNumber" label="身份证号" width="250"></el-table-column>
                        <el-table-column property="des" label="监护人姓名" ></el-table-column>
                    </el-table>

                    <el-steps :active="step" align-center v-show="showProgress"  style="margin-top: 28px"   ><!--:finish-status="'success'"-->
                        <el-step :title="'提交报名信息'" :description="'【'+checkItem.title+'】\xa0'+checkItem.createTime"  ></el-step>
                        <el-step title="报名信息审核中"   description=""  >

                            <span slot="description" style="color: red"  v-if="checkItem.summary!=''&&checkItem.summary!=null&&typeof(checkItem.summary)!='undefined'" >
                                修改意见：{{checkItem.summary}}
                            </span>

                            <span slot="description" style="color: red"  v-else ></span>
                        </el-step>
                        <el-step title="审核通过报名成功" description="" ></el-step>
                    </el-steps>
                </el-form>


                <span slot="footer"  class="dialog-footer"  >
                    <el-button   type="primary" @click="doQuery">查询</el-button>
                    <el-button   type="primary" @click="doUpdate">修改资料</el-button>
            </span>
            </el-dialog>


            <el-dialog title="团体名单" :visible.sync="dialogTableVisible" :fullscreen="true"  :center="true">
                <el-table :data="gridData">
                    <el-table-column property="title" label="学生姓名" width="150"></el-table-column>
                    <el-table-column property="org" label="所属团体" width="250"></el-table-column>
                    <el-table-column property="grade" label="分组" width="200"></el-table-column>
                    <el-table-column property="sex" label="性别" width="100"></el-table-column>
                    <el-table-column property="school" label="就读学校" width="200"></el-table-column>
                    <el-table-column property="phone" label="手机号" width="200"></el-table-column>
                    <el-table-column property="idNumber" label="身份证号" width="250"></el-table-column>
                    <el-table-column property="des" label="监护人姓名" ></el-table-column>
                </el-table>

                <span slot="footer"  class="dialog-footer"  >
                    <el-button   type="primary" @click="dialogTableVisible = false">确定</el-button>
                </span>
            </el-dialog>


            <el-form-item size="large">
                <el-button type="primary" @click="doAdd" v-loading.fullscreen.lock="showLoad" v-preventReClick>修改</el-button>
               <!-- <el-button @click="resetForm">重置</el-button>-->
                <el-button  @click="check"  v-preventReClick>查询</el-button>
                <!--<el-button @click="readExcel">读取excel</el-button>-->
            </el-form-item>
        </el-form>
    </div>
    </transition>
</template>
<script>
    import { getAction, postAction,httpAction } from '../../api/manage';
    import preventReClick from '../../utils/preventReClick';
    //import * as XLSX from "xlsx";
    const XLSX = require('xlsx');
    //webpackconfig.plugin.push(new XLSX);
    export default {
        components: {},
        props: [],
        data() {
            return {
                formData: {
                    id:"",
                    title: "",
                    orgUser: "",
                    code:"",
                    type: "学校",
                    field119: null,
                    field120: null,
                    field122: null,
                    field125: null,
                    field126: null,
                    field133: null,
                    phone: "",
                    captcha: "",
                    file1:null,
                    file2:null,
                    file3:null,
                    file4:null,
                    file5:null,
                    file6:null,
                    file7:null,
                    file8:null,
                    checkPhone:"",
                    checkCaptcha: "",
                    matchId:10

                },
                isMatch:false,
                checkItem:{grade:'',createTime:'',summary:'',title:'',school:'',org:'',orgCode:'',sex:'',des:'',idPath:'',fstatus:''},
                step:1,
                showProgress:false,
                showCheck:false,
                isEdit:false,
                dialogTableVisible:false,
                gridData: [],
                gridData2:[],
                dsActors:[],

                imgUrl:"",
                showDiv:false,
                showLoad:false,
                qrVisible:false,
                smsTime:0,
                unSend:true,
                isPhone:false,
                phoneMessage:"",
                smsTxt:"发送验证码",

                rules: {
                    title: [{
                        required: true,
                        message: '请输入团体名称',
                        trigger: 'blur'
                    }],
                    orgUser: [{
                        required: true,
                        message: '请输入领队姓名',
                        trigger: 'blur'
                    }],
                    type: [{
                        required: true,
                        message: '团体性质不能为空',
                        trigger: 'change'
                    }],
                    phone: [{
                        required: true,
                        message: '请输入领队手机号',
                        trigger: 'blur'
                    }],
                    captcha: [{
                        required: true,
                        message: '请输入短信验证码',
                        trigger: 'blur'
                    }],
                },
                file1List: [],
                file2List: [],
                file3List: [],
                file4List: [],
                file5List: [],
                file6List: [],
                file7List: [],
                file8List: [],
                typeOptions: [{
                    "label": "机构",
                    "value": "机构"
                }, {
                    "label": "学校",
                    "value": "学校"
                }],
            }
        },
        computed: {},
        watch: {
            '$route' (to, from) {
                if(from.path==="/team"){
                    console.log(this.$route.params.matchId);
                }
            }},
        created() {

            if(this.$route.params.matchId!=""&&typeof (this.$route.params.matchId)!="undefined"){
                this.formData.matchId = this.$route.params.matchId;
                this.isMatch=true;
            }
            else{
                this.isMatch=false;
            }

            this.showDiv=true;
            /////验证码计时
            this.smsTime =   window.localStorage.getItem("smsTime");
            if(this.smsTime!=null&&this.smsTime!=0&&typeof(this.smsTime)!="undefined"){
                this.unSend=false;
                let timer = setInterval(() => {
                    this.smsTime--
                    window.localStorage.setItem("smsTime",this.smsTime);
                    if (this.smsTime <= 0) {
                        this.smsTime=0;
                        clearInterval(timer)
                        this.unSend = true;
                    }
                }, 1000);
            }
        },
        mounted() {
            this.showCheck=true;
        },
        methods: {

            check(){
                this.showCheck=true;

            },

            doQuery(){
                if(!this.isMatch){
                    this.showMessage(1,"查询失败，赛事Id为空");
                    return;
                }

                this.gridData2=[];
                let params = {
                    title: this.formData.checkTitle,
                    phone:this.formData.checkPhone,
                    captcha: this.formData.checkCaptcha,
                    matchId:this.formData.matchId,

                };
                let that = this;
                getAction("/sys/competition/checkTeam",params).then((res) => {
                    if (res.success) {
                        that.checkItem = res.result;
                        that.step=1;
                        if(that.checkItem.fstatus!=""&&typeof(that.checkItem.fstatus)!="undefined"){
                            if(that.checkItem.fstatus=="1"){
                                that.step = parseInt(that.checkItem.fstatus)+2;
                            }
                            else{
                                if(that.checkItem.summary!=''&&that.checkItem.summary!=null&&typeof(that.checkItem.summary)!='undefined'){
                                    that.step = parseInt(that.checkItem.fstatus)+2;
                                }
                                else{
                                    that.step = parseInt(that.checkItem.fstatus)+1;
                                }

                            }

                        }
                        for(let i=0;i<that.checkItem.personList.length;i++){
                            that.gridData2.push(that.checkItem.personList[i]);
                        }
                        that.showProgress=true;
                    }else{
                        that.showMessage(1,res.message);
                        return;
                    }

                });


            },

            /////将查询到的数据都读取出来并且把查询界面独立出一个单独界面 领队手机号禁止修改 按钮也修改下
            doUpdate(){

                if(!this.showProgress){
                    this.showMessage(1,"请先查询报名信息");
                    return;
                }

                if(this.checkItem.fstatus=="1"){
                    this.showMessage(1,"禁止修改，报名信息已审核");
                    return;
                }

                this.formData.title = this.checkItem.title;
                this.formData.orgUser = this.checkItem.orgUser;
                this.formData.phone = this.checkItem.phone;
                this.formData.id = this.checkItem.id;
                this.formData.code = this.checkItem.code;

                let prefix = 'http://img.tmxiangqi.com/team/'+this.formData.matchId+'/'+this.checkItem.phone+'/'
                let suffix = "?timestamp="+Date.now();
                if(!this.checkNull(this.checkItem.reportPath)){
                    this.file2List=[{name: this.checkItem.reportPath, url:prefix+this.checkItem.reportPath+suffix}];
                    //this.file1Img = prefix+this.checkItem.reportPath+suffix;
                }
                if(!this.checkNull(this.checkItem.excelPath)){
                    this.file3List=[{name: this.checkItem.excelPath, url:prefix+this.checkItem.excelPath+suffix}];
                    //this.file2Img = prefix+this.checkItem.excelPath+suffix;
                }
                if(!this.checkNull(this.checkItem.insurancePath)){
                    this.file4List=[{name: this.checkItem.insurancePath, url:prefix+this.checkItem.insurancePath+suffix}];
                    //this.file3Img = prefix+this.checkItem.insurancePath+suffix;
                }
                if(!this.checkNull(this.checkItem.certPath)){
                    this.file5List=[{name: this.checkItem.certPath, url:prefix+this.checkItem.certPath+suffix}];
                }
                if(!this.checkNull(this.checkItem.chargePath)){
                    this.file6List=[{name: this.checkItem.chargePath, url:prefix+this.checkItem.chargePath+suffix}];
                }
                if(!this.checkNull(this.checkItem.rankPath)){
                    this.file7List=[{name: this.checkItem.rankPath, url:prefix+this.checkItem.rankPath+suffix}];
                }
                if(!this.checkNull(this.checkItem.zsPath)){
                    this.file8List=[{name: this.checkItem.zsPath, url:prefix+this.checkItem.zsPath+suffix}];
                }
                this.showCheck=false;
                this.isEdit = true;
            },

            checkNull(item){
                if(item==null||item==""||typeof(item)=="undefined"){
                    return true;
                }
                else{
                    return false;
                }
            },

            sendCheckSms(){
                if(!this.validateCheckPhone()){
                    this.showMessage(1,"请填写正确手机号！")
                }
                else{
                    let params = {
                        phone:this.formData.checkPhone
                    }
                    postAction("/sys/sendSms",params).then((res) => {
                        if (res.success) {
                            this.smsTime= 60;//*1000;
                            this.showMessage(0,"验证码发送成功！");

                            this.unSend = false;
                            this.smsTime=60;
                            let timer = setInterval(() => {
                                this.smsTime--
                                window.localStorage.setItem("smsTime",this.smsTime);
                                if (this.smsTime === 0) {
                                    clearInterval(timer)
                                    this.unSend = true;
                                }
                            }, 1000);
                            return;
                        } else {
                            this.showMessage(1,"验证码发送失败！");
                            return;
                        }
                    })
                }


            },

            validateCheckPhone(){
                if(!this.formData.checkPhone){
                    this.isPhone=false;
                    return false;
                }else{
                    if(new RegExp(/^1[3|4|5|7|8|9][0-9]\d{8}$/).test(this.formData.checkPhone)){
                        this.isPhone=true;
                        return  true;

                    }else{
                        this.isPhone=false;
                        return false;
                    }
                }
                this.isPhone=true;
                return true;
            },

            readExcel() {

                this.dialogTableVisible=true;
                //表格导入

                var that = this;

                const files = this.file3List;//e.target.files;

                if (!that.verifyExcelFileOnUpload(files)) {//此处方法在下方2.1处

                    //驗證文件格式

                    this.$message.error("文件格式错误");
                    return false;

                }

                const fileReader = new FileReader();

                //当文件加载成功后执行

                fileReader.onload = ev => {

                    try {

                        that.dsActors = [];

                        const data = ev.target.result;

                        const workbook = XLSX.read(data, {

                            type: "binary"

                        });

                        var sheet_name_list = workbook.SheetNames;


                        const ws = XLSX.utils.sheet_to_json(

                            workbook.Sheets[sheet_name_list[0]],

                            { header: 1 }

                        );

                        for(let i=1;i<ws.length;i++){

                            let pobj = {};
                            pobj.title=ws[i][0];
                            pobj.org=ws[i][1];
                            pobj.grade=ws[i][2];
                            pobj.sex=ws[i][3];
                            pobj.school=ws[i][4];
                            pobj.phone=ws[i][5];
                            pobj.idNumber=ws[i][6];
                            pobj.des=ws[i][7];
                            that.gridData.push(pobj);

                        }

                        //注：变量ws   就是获取到文件的数据

                        if (that.verifyDataAfterUpload(ws)) {//此方法在下方2.2处(为业务代码可忽略)

                            var mode = {

                                actorList: this.dsActors,

                                LoginUserId:this.$store.state.currentUser.Id

                            }; //此处为业务代码数据模型，

                            //that.checkUploadData(mode);

                        } else {

                            this.$message.error("導入的數據有誤，請檢查高亮部分");
                            /*this.$data.alertConfig.show(

                                this.$t("導入的數據有誤，請檢查高亮部分"),

                                "danger",

                                300

                            );*/

                        }

                    } catch (e) {

                        return false;

                    }

                };

                fileReader.readAsBinaryString(this.formData.file3);


            }, //讀取Excel文件


            //驗證Excel文件格式
            verifyExcelFileOnUpload(files) {

                console.log(files[0].size);

                if (files[0].size > 2 * 1024 * 1024) {

                    this.$message.error("上傳文件太大，僅支持2MB以下的文件");
                    /*this.$data.alertConfig.show(
                        this.$t("上傳文件太大，僅支持2MB以下的文件"),
                        "danger",
                        3
                    );*/

                    return false;

                }

                if (files.length <= 0) {

                    //如果没有文件名

                    return false;

                } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {

                    //此处代码块内容为我的代码，做示范性作用，执行有可能报错，

                    /*

                          $("#i-file").val(""); //清空文件加載路徑

                          this.$data.alertConfig.show(

                            this.$t("上傳文件格式錯誤，目前只支援xls或xlsx格式"),

                            "danger",

                            3

                          );

                          */

                    return false;

                }

                return true;

            }, //驗證Excel文件格式

            verifyDataAfterUpload(ws) {

                var that = this;

                that.dsActors = []; //清空接收数据

                const actorTypes = [300010, 300020, 300030]; //參與者類型

                var localValidatePassed = true;

                var tempName = [];

                var j = 0; //行號  ID

                for (var i = 2; i < ws.length; i++) {

                    var sheetData = {

                        UserName: ws[i][0] != undefined ? ws[i][0] : "",

                        Name: ws[i][1] != undefined ? ws[i][1] : "",

                        TypeId: ws[i][2] != undefined ? ws[i][2] : "",

                        ErrorCellsIndex: [],

                        Id: i - 2

                    };

                    if (sheetData.Name == "") {

                        sheetData.ErrorCellsIndex.push(1);

                        localValidatePassed = false;

                    }

                    if (sheetData.UserName == "") {

                        sheetData.ErrorCellsIndex.push(0);

                        localValidatePassed = false;

                    }

                   /* if (actorTypes.indexOf(sheetData.TypeId) == -1) {

                        sheetData.ErrorCellsIndex.push(2);

                        localValidatePassed = false;

                    }*/

                    tempName.push(sheetData.UserName);

                    that.dsActors.push(sheetData);

                }

                var duplicateDataValidate = that.validateDuplicateData(tempName);

                localValidatePassed = localValidatePassed && duplicateDataValidate;

                return localValidatePassed;

            }, //判斷加載數據是否合格

            validateDuplicateData(arr) {

                var that = this;

                var list = [];

                for (var i = 0; i < arr.length; i++) {

                    var hasRead = false;

                    for (var k = 0; k < list.length; k++) {

                        if (i == list[k]) {

                            hasRead = true;

                        }

                    }

                    if (hasRead) {

                        break;

                    }

                    var _index = i,

                        haveSame = true;

                    for (var j = i + 1; j < arr.length; j++) {

                        if (arr[i] == arr[j]) {

                            list.push(j);

                            if (that.dsActors[i].ErrorCellsIndex.indexOf(0) == -1) {

                                that.dsActors[i].ErrorCellsIndex.push(0);

                            }

                            that.dsActors[j].ErrorCellsIndex.push(0);

                            haveSame = false;

                        }

                    }

                }

                return haveSame;

            }, //驗證重複用戶名



            showMessage(type,msg){
                if(type==0){
                    this.$message({
                        message: msg,
                        type: 'success'
                    });
                }
                else{
                    this.$message.error(msg);
                }

            },

            sendSms(){
                if(!this.validatePhone()){
                   this.showMessage(1,"请填写正确手机号！")
                }
                else{
                    let params = {
                        phone:this.formData.phone
                    }
                    postAction("/sys/sendSms",params).then((res) => {
                        if (res.success) {
                            this.smsTime= 60;//*1000;
                            this.showMessage(0,"验证码发送成功！");

                            this.unSend = false;
                            this.smsTime=60;
                            let timer = setInterval(() => {
                                this.smsTime--
                                window.localStorage.setItem("smsTime",this.smsTime);
                                if (this.smsTime === 0) {
                                    clearInterval(timer)
                                    this.unSend = true;
                                }
                            }, 1000);
                            return;
                        } else {
                            this.showMessage(1,"验证码发送失败！");
                            return;
                        }
                    })
                }


            },

            validatePhone(){
                if(!this.formData.phone){
                    this.phoneMessage="请填写手机号！";
                    this.isPhone=false;
                    return false;
                }else{
                    //update-begin--Author:kangxiaolin  Date:20190826 for：[05] 手机号不支持199号码段--------------------
                    if(new RegExp(/^1[3|4|5|7|8|9][0-9]\d{8}$/).test(this.formData.phone)){
                        //update-end--Author:kangxiaolin  Date:20190826 for：[05] 手机号不支持199号码段--------------------
                        this.phoneMessage = "";
                        this.isPhone=true;
                        return  true;

                    }else{
                        this.phoneMessage = "请输入正确格式的手机号码!";
                        this.isPhone=false;
                        return false;
                    }
                }
                this.phoneMessage ="";
                this.isPhone=true;
                return true;
            },




            handlerExceed(){
              this.$message.error("只允许上传单个文件！")
            },


            file1Upload(file,fileList) {
                let isRightSize = file.size / 1024 / 1024 < 10
                if (!isRightSize) {
                    this.$message.error('文件大小超过 10MB')
                }
                let isAccept = new RegExp('image/jpeg|image/png|application/pdf').test(file.raw.type)
                if (!isAccept) {
                    this.showMessage(1,'请选择jpg,png或pdf类型的文件')
                }
                if(isRightSize&&isAccept){
                    this.file1List = fileList;
                    this.formData.file1 = file.raw;
                    if(file.raw.type!="application/pdf"){
                        this.imgPreview(file.raw,"1");
                    }
                }

                return isRightSize && isAccept
            },
            file2Upload(file,fileList) {
                let isRightSize = file.size / 1024 / 1024 < 10
                if (!isRightSize) {
                    this.$message.error('文件大小超过 10MB')
                }
                let isAccept = new RegExp('image/jpeg|image/png|application/pdf').test(file.raw.type)
                if (!isAccept) {
                    this.showMessage(1,'请选择jpg,png或pdf类型的文件')
                }
                if(isRightSize&&isAccept){
                    this.file2List = fileList;
                    this.formData.file2 = file.raw;
                    if(file.raw.type!="application/pdf"){
                        this.imgPreview(file.raw,"2");
                    }
                }
                return isRightSize && isAccept
            },
            file3Upload(file,fileList) {
                let isRightSize = file.size / 1024 / 1024 < 20
                if (!isRightSize) {
                    this.$message.error('文件大小超过 10MB')
                }
                let isAccept = new RegExp('application/vnd.ms-excel|application/vnd.openxmlformats-officedocument.spreadsheetml.sheet').test(file.raw.type)
                if (!isAccept) {
                    this.showMessage(1,'请选择xls,xlsx类型的文件')
                }

                if(isRightSize&&isAccept){
                    this.file3List = fileList;
                    this.formData.file3 = file.raw;
                    /*if(file.raw.type!="application/pdf"){
                        this.imgPreview(file.raw,"3");
                    }*/
                    this.gridData=[];
                    //this.readExcel();
                }
                return  isRightSize && isAccept;
            },
            file4Upload(file,fileList) {
                let isRightSize = file.size / 1024 / 1024 < 30
                if (!isRightSize) {
                    this.$message.error('文件大小超过 30MB')
                }
                let type = file.raw.name.substring(file.raw.name.lastIndexOf("."));
                let isAccept = new RegExp('image/jpeg|image/png|application/pdf|.rar|.zip|application/vnd.ms-excel|application/vnd.openxmlformats-officedocument.spreadsheetml.sheet').test(file.raw.type)
                if(type==".rar"){
                    isAccept=true;
                }
                if (!isAccept) {
                    this.showMessage(1,'请选择jpg,png,zip或pdf类型的文件')
                }

                if(isRightSize&&isAccept){
                    this.file4List = fileList;
                    this.formData.file4 = file.raw;
                    if(file.raw.type!="application/pdf"&&file.raw.type!="application/zip"&&file.raw.type!="application/rar"&&file.raw.type!=".rar"&&file.raw.type!=".zip"){
                        this.imgPreview(file.raw,"4");
                    }
                }
                return isRightSize && isAccept
            },

            file5Upload(file,fileList) {
                let isRightSize = file.size / 1024 / 1024 < 30
                if (!isRightSize) {
                    this.$message.error('文件大小超过 30MB')
                }
                let type = file.raw.name.substring(file.raw.name.lastIndexOf("."));
                let isAccept = new RegExp('image/jpeg|image/png|application/pdf|.rar|.zip|application/vnd.ms-excel|application/vnd.openxmlformats-officedocument.spreadsheetml.sheet').test(file.raw.type)
                if(type==".rar"){
                    isAccept=true;
                }
                if (!isAccept) {
                    this.showMessage(1,'请选择jpg,png,zip或pdf类型的文件')
                }

                if(isRightSize&&isAccept){
                    this.file5List = fileList;
                    this.formData.file5 = file.raw;
                    if(file.raw.type!="application/pdf"&&file.raw.type!="application/zip"&&file.raw.type!="application/rar"&&file.raw.type!=".rar"&&file.raw.type!=".zip"){
                        this.imgPreview(file.raw,"5");
                    }
                }
                return isRightSize && isAccept
            },

            file6Upload(file,fileList) {
                let isRightSize = file.size / 1024 / 1024 < 10
                if (!isRightSize) {
                    this.$message.error('文件大小超过 10MB')
                }
                let isAccept = new RegExp('image/jpeg|image/png|application/pdf').test(file.raw.type)
                if (!isAccept) {
                    this.showMessage(1,'请选择jpg,png或pdf类型的文件')
                }
                if(isRightSize&&isAccept){
                    this.file6List = fileList;
                    this.formData.file6 = file.raw;
                    if(file.raw.type!="application/pdf"){
                        this.imgPreview(file.raw,"6");
                    }
                }
                return isRightSize && isAccept;
            },

            file7Upload(file,fileList) {
                let isRightSize = file.size / 1024 / 1024 < 30
                if (!isRightSize) {
                    this.$message.error('文件大小超过 30MB')
                }
                let type = file.raw.name.substring(file.raw.name.lastIndexOf("."));
                let isAccept = new RegExp('image/jpeg|image/png|application/pdf|.rar|.zip|application/vnd.ms-excel|application/vnd.openxmlformats-officedocument.spreadsheetml.sheet').test(file.raw.type)
                if(type==".rar"){
                    isAccept=true;
                }
                if (!isAccept) {
                    this.showMessage(1,'请选择jpg,png,rar,zip或pdf类型的文件')
                }

                if(isRightSize&&isAccept){
                    this.file7List = fileList;
                    this.formData.file7 = file.raw;
                    if(file.raw.type!="application/pdf"&&file.raw.type!="application/zip"&&file.raw.type!="application/rar"&&file.raw.type!=".rar"&&file.raw.type!=".zip"){
                        this.imgPreview(file.raw,"7");
                        //this.toZip(this.formData.file4);
                    }
                }
                return isRightSize && isAccept
            },

            file8Upload(file,fileList) {
                let isRightSize = file.size / 1024 / 1024 < 30
                if (!isRightSize) {
                    this.$message.error('文件大小超过 30MB')
                }
                let type = file.raw.name.substring(file.raw.name.lastIndexOf("."));
                let isAccept = new RegExp('image/jpeg|image/png|application/pdf|.rar|.zip|application/vnd.ms-excel|application/vnd.openxmlformats-officedocument.spreadsheetml.sheet').test(file.raw.type)
                if(type==".rar"){
                    isAccept=true;
                }
                if (!isAccept) {
                    this.showMessage(1,'请选择jpg,png,rar,zip或pdf类型的文件')
                }

                if(isRightSize&&isAccept){
                    this.file8List = fileList;
                    this.formData.file8 = file.raw;
                    if(file.raw.type!="application/pdf"&&file.raw.type!="application/zip"&&file.raw.type!="application/rar"&&file.raw.type!=".rar"&&file.raw.type!=".zip"){
                        this.imgPreview(file.raw,"8");
                        //this.toZip(this.formData.file4);
                    }
                }
                return isRightSize && isAccept
            },


            doAdd(){
                let that = this;

                /////////////////
                /*this.showMessage(1,"修改失败，报名已结束");
                return;*/

                if(!this.isMatch){
                    this.showMessage(1,"修改失败，赛事Id为空");
                    return;
                }

                if(this.checkItem.fstatus=="1"){
                    this.showMessage(1,"禁止修改，报名信息已审核");
                    return;
                }
                /*if(this.formData.captcha==""){
                    this.showMessage(1,"请输入验证码");
                    return;
                }*/

               /* if(!this.isPhone){
                    this.showMessage(1,"请输入正确的手机号");
                    return;
                }*/

                if(this.formData.title==""){
                    this.showMessage(1,"请输入团体名称");
                    return;
                }

                /*if(this.gridData.length==0){
                    this.showMessage(1,"请导入报名表Excel！");
                    return;
                }*/

                let params = {
                    /////标题也要改成对应的
                    /////matchId先固定1是象棋 2是围棋 3是台江区第53届中小学生运动会象棋比赛  后期改成动态
                    matchId:this.formData.matchId,
                    title: this.formData.title,
                    type:this.formData.type,
                    phone:this.formData.phone,
                    orgUser:this.formData.orgUser,
                    createBy:"网页端",
                    captcha: this.formData.captcha,
                    personList:this.gridData
                };

                if(this.isEdit){
                    params.id = this.formData.id;
                    params.code = this.formData.code;
                }

                let fileParams = new FormData()
                let file1 = this.formData.file1;
                let file2 = this.formData.file2;
                let file3 = this.formData.file3;
                let file4 = this.formData.file4;
                let file5 = this.formData.file5;
                let file6 = this.formData.file6;
                let file7 = this.formData.file7;
                let file8 = this.formData.file8;

                let type1 = "";
                let type2 = "";
                let type3 = "";
                let type4 = "";
                let type5 = "";
                let type6 = "";
                let type7 = "";
                let type8 = "";



                if(file1!=[]&&file1!=null&&typeof (file1)!="undefined"){
                    type1 = file1.name.substring(file1.name.lastIndexOf("."));
                    fileParams.append('files', file1,"teamPath"+type1);
                }
               /* else{
                    if(this.formData.type=="机构"){
                        this.showMessage(1,"请上传营业执照");
                        return;
                    }
                }*/

                if(file2!=[]&&file2!=null&&typeof (file2)!="undefined"){
                    type2 = file2.name.substring(file2.name.lastIndexOf("."));
                    fileParams.append('files', file2,"reportPath"+type2);
                }
               /* else{
                    this.showMessage(1,"请上传报名表盖章");
                    return;
                }*/

                if(file6!=[]&&file6!=null&&typeof (file6)!="undefined"){
                    type6 = file6.name.substring(file6.name.lastIndexOf("."));
                    fileParams.append('files', file6,"chargePath"+type6);
                }

                if(file4!=[]&&file4!=null&&typeof (file4)!="undefined"){
                    type4 = file4.name.substring(file4.name.lastIndexOf("."));
                    let newName="insurancePath"+type4;
                    let tmpFile = "";
                    if(type4==".rar"){
                        tmpFile=new File([file4],newName,{type:'application/rar'});
                    }else{
                        tmpFile=new File([file4],newName,{type:'application/zip'});
                    }

                    fileParams.append('files', file4,"insurancePath"+type4);
                }
                /*else{
                    this.showMessage(1,"请上传团体保单");
                    return;
                }*/

                //////等级证书压缩包
                /*if(file7!=[]&&file7!=null&&typeof (file7)!="undefined"){
                    type7 = file7.name.substring(file7.name.lastIndexOf("."));
                    let newName="rankPath"+type7;
                    let tmpFile = "";
                    if(type7==".rar"){
                        tmpFile=new File([file7],newName,{type:'application/rar'});
                    }else{
                        tmpFile=new File([file7],newName,{type:'application/zip'});
                    }

                    fileParams.append('files', file7,"rankPath"+type7);
                }*/
                /*else{
                    this.showMessage(1,"请上传等级证书");
                    return;
                }*/

                ////////获奖证书压缩包
               /* if(file8!=[]&&file8!=null&&typeof (file8)!="undefined"){
                    type8 = file8.name.substring(file8.name.lastIndexOf("."));
                    let newName="zsPath"+type8;
                    let tmpFile = "";
                    if(type8==".rar"){
                        tmpFile=new File([file8],newName,{type:'application/rar'});
                    }else{
                        tmpFile=new File([file8],newName,{type:'application/zip'});
                    }

                    fileParams.append('files', file8,"zsPath"+type8);
                }*/


                if(file5!=[]&&file5!=null&&typeof (file5)!="undefined"){
                    type5 = file5.name.substring(file5.name.lastIndexOf("."));
                    let newName="certPath"+type5;
                    let tmpFile = "";
                    if(type5==".rar"){
                        tmpFile=new File([file5],newName,{type:'application/rar'});
                    }else{
                        tmpFile=new File([file5],newName,{type:'application/zip'});
                    }

                    fileParams.append('files', tmpFile,"certPath"+type5);
                }

                if(file3!=[]&&file3!=null&&typeof (file3)!="undefined"){
                    type3 = file3.name.substring(file3.name.lastIndexOf("."));
                    if(type3==".xls"||type3==".xlsx"){
                        fileParams.append('files', file3,"excelPath"+type3);
                    }
                    else{
                        this.showMessage(1,"报名表请上传excel格式文件");
                        return;
                    }

                }
                /*else{
                    this.showMessage(1,"请上传报名表excel");
                    return;
                }*/




                this.showLoad=true;
                let header = "Content-Type': 'multipart/form-data";

                //////在这里把isEdit和matchid传进去 编辑状态不判断手机是否重复
                let isEditStr = "";
                if(this.isEdit){
                    isEditStr = "Y"
                }
                else{
                    isEditStr = "N"
                }

                let mobile = that.formData.phone+","+this.formData.matchId+","+isEditStr
                setTimeout(function () {
                postAction("/sys/competition/importTeamImg/"+mobile,fileParams,header).then((res) => {
                    that.showLoad=false;
                    if (res.success) {
                        params["teamPath"] = res.result.teamPath;
                        params["reportPath"] = res.result.reportPath;
                        params["excelPath"] = res.result.excelPath;
                        params["insurancePath"] = res.result.insurancePath;
                        params["certPath"] = res.result.certPath;
                        params["chargePath"] = res.result.chargePath;
                        params["rankPath"] = res.result.rankPath;
                        params["zsPath"] = res.result.zsPath;
                        let postUrl = "addTeam";
                        if(that.isEdit){
                            postUrl="updateTeam";
                        }

                        postAction("/sys/competition/"+postUrl,params).then((res) => {
                            if (res.success) {
                                that.formData.file1=null;
                                that.formData.file2=null;
                                that.formData.file3=null;
                                that.formData.file4=null;
                                that.formData.file5=null;
                                that.formData.file6=null;
                                that.formData.file7=null;
                                that.formData.file8=null;
                                this.file1List=[];
                                this.file2List=[];
                                this.file3List=[];
                                this.file4List=[];
                                this.file5List=[];
                                this.file6List=[];
                                this.file7List=[];
                                this.file8List=[];
                                that.formData.title="";
                                that.formData.phone="";
                                that.formData.type="学校";
                                that.formData.captcha="";
                                that.formData.orgUser="";

                                let code = res.result;
                                if(that.formData.matchId==10){
                                    that.qrVisible=true;
                                }
                                if(that.isEdit){
                                    that.showMessage(0,"修改成功");
                                }else{
                                    that.showMessage(0,"报名成功");
                                }

                                that.isEdit=false;
                                return;
                            } else {
                                that.showMessage(1,res.message);
                                return ;
                            }
                        })

                    }
                    else{
                        that.showLoad =false;
                        that.showMessage(1,"上传失败："+res.message);
                    }


                });},1000);

            },


            // 处理图片
            imgPreview(file,type) {
                let self = this
                // 看支持不支持FileReader
                if (!file || !window.FileReader) return;
                const size = file.size/1024
                /* console.log(`图片大小 ===> ${file.size/1024}k`);
                 console.log('图片压缩：',this.compressSwitch?'开':'关');
                 console.log('图片压缩阈值：',this.threshold+'k');
                 console.log('图片压缩降帧值：',this.quality);*/
                //if (/^image/.test(file.type) && size >= this.threshold && this.compressSwitch) {
                // 创建一个reader
                let reader = new FileReader()
                // 将图片2将转成 base64 格式
                reader.readAsDataURL(file)
                // 读取成功后的回调
                reader.onloadend = function() {
                    let result = this.result
                    let img = new Image()
                    img.src = result
                    img.onload = function() {
                        // 压缩
                        let data = self.compress(img,file.name,file.type)
                        console.log(`压缩后 ===>${data.fileData.size/1024}k`);
                        //self.$attrs.value[index].content = data.base64Data
                        file = data.fileData;
                        if(type=="1"){
                            self.formData.file1 = file;
                        }
                        else if(type=="2"){
                            self.formData.file2 = file;
                        }
                        else if(type=="3"){
                            self.formData.file3 = file;
                        }
                        else if(type=="4"){
                            self.formData.file4 = file;
                        }
                        else if(type=="5"){
                            self.formData.file5 = file;
                        }
                        else if(type=="6"){
                            self.formData.file6 = file;
                        }


                    }
                }
                //}
            },
            // 压缩图片
            compress(img, name, type) {
                let canvas = document.createElement('canvas')
                let ctx = canvas.getContext('2d')
                //瓦片canvas
                let tCanvas = document.createElement('canvas')
                let tctx = tCanvas.getContext('2d')
                // let initSize = img.src.length;
                let width = img.width
                let height = img.height
                //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
                let ratio
                if ((ratio = (width * height) / 4000000) > 1) {
                    // console.log("大于400万像素");
                    ratio = Math.sqrt(ratio)
                    width /= ratio
                    height /= ratio
                } else {
                    ratio = 1
                }
                canvas.width = width
                canvas.height = height
                //    铺底色
                ctx.fillStyle = '#fff'
                ctx.fillRect(0, 0, canvas.width, canvas.height)
                //如果图片像素大于100万则使用瓦片绘制
                let count
                if ((count = (width * height) / 1000000) > 1) {
                    // console.log("超过100W像素");
                    count = ~~(Math.sqrt(count) + 1) //计算要分成多少块瓦片
                    //      计算每块瓦片的宽和高
                    let nw = ~~(width / count)
                    let nh = ~~(height / count)
                    tCanvas.width = nw
                    tCanvas.height = nh
                    for (let i = 0; i < count; i++) {
                        for (let j = 0; j < count; j++) {
                            tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh)
                            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh)
                        }
                    }
                } else {
                    ctx.drawImage(img, 0, 0, width, height)
                }
                //进行压缩
                let ndata = canvas.toDataURL('image/jpeg', this.quality)
                tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
                return {base64Data:ndata,fileData:this.dataURLtoFile(ndata,name,type)}
            },
            //将base64转换为文件
            dataURLtoFile(dataurl,name,type) {
                name = name ? name : '图片'
                type = type ? type : 'jpg'
                var arr = dataurl.split(','),
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n)
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n)
                }
                return new File([u8arr], name, {
                    type: type
                })
            },


            resetForm() {
                this.$refs['elForm'].resetFields();

                this.file1List=[];
                this.file2List=[];
                this.file3List=[];
                this.file4List=[];
                this.file5List=[];
                this.file6List=[];
                this.file7List=[];
                this.file8List=[];
                this.formData.file1=null;
                this.formData.file2=null;
                this.formData.file3=null;
                this.formData.file4=null;
                this.formData.file5=null;
                this.formData.file6=null;
                this.formData.file7=null;
                this.formData.file8=null;
            },
            qrClose(){
                this.qrVisible=false;
            }
        }
    }

</script>
<style>
    .transition-box {
    }
</style>



// WEBPACK FOOTER //
// src/views/teamCheck/index.vue